import { Stack } from '@mui/material';
import { useCallback, useState } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { TextInput } from '@/components/form/baseInputs/TextInput';
import { DialogModal } from '@/components/modals/DialogModal/DialogModal';
import { stripAngleBrackets } from '@/utils/formatting/strings';

export function getTrimmedDisplayName(displayName: string): string {
  return displayName.replace(/&nbsp;/g, ' ').trim();
}

export interface PresentationTemplateStageEditorDisplayNamePromptProps {
  onClose: () => void;
  onSubmit: (newTitle: string) => void;
}

export function PresentationTemplateStageEditorDisplayNamePrompt({
  onClose,
  onSubmit,
}: PresentationTemplateStageEditorDisplayNamePromptProps) {
  const [newDisplayName, setNewDisplayName] = useState<string>('');
  const trimmedDisplayName = getTrimmedDisplayName(newDisplayName);

  const onClickSave = useCallback(() => {
    onSubmit(trimmedDisplayName);
    onClose();
  }, [trimmedDisplayName, onClose, onSubmit]);

  return (
    <DialogModal
      isOpen
      heading="New template name"
      onClose={onClose}
      actions={
        <Stack
          width="100%"
          spacing={2}
          direction="row"
          justifyContent="stretch"
        >
          <Button onClick={onClose} variant="secondary" size="sm" fullWidth>
            Cancel
          </Button>
          <Button
            onClick={onClickSave}
            variant="primary"
            size="sm"
            fullWidth
            disabled={!trimmedDisplayName}
          >
            Submit
          </Button>
        </Stack>
      }
    >
      <TextInput
        label="Template name"
        value={newDisplayName}
        onChange={(e) => setNewDisplayName(stripAngleBrackets(e.target.value))}
        autoFocus
      />
    </DialogModal>
  );
}
